import React from "react";
import RadioSelect from "../../../../../components/VectorFLOW/commons/MTO/RadioSelect";
import {
  StepGroup,
  StepLabel,
  StepperWrapper,
  bufferAssignment,
  stepMode,
  stepGroupAlias,
} from "./RouteAssignment.styled.css";

const BufferAssignment = ({
  theme,
  bufferMaster,
  selectedBuffers,
  setSelectedBuffers,
  isEditable,
}: any) => {
  const onValueChange = (newValue: any, type: any) => {
    const buffers = [...selectedBuffers];
    if (type === "prod") {
      buffers[0] = newValue;
    } else if (type === "proc") {
      buffers[1] = newValue;
    }
    setSelectedBuffers(buffers);
  };

  return (
    <div
      className={`${StepperWrapper} ${bufferAssignment}`}
      key="buffer-assignment"
    >
      <div
        className={`${StepGroup} ${stepGroupAlias}`}
        style={{ width: "100%" }}
        key={`buffer-assignment-1`}
      >
        <div className={StepLabel}>Production Buffer</div>
        <RadioSelect
          key={`buffer-assignment-1-1`}
          isDisabled={!isEditable}
          theme={theme}
          options={bufferMaster?.prodMaster}
          value={selectedBuffers[0] || null}
          isClearable
          onChange={(newValue: any) => onValueChange(newValue, "prod")}
          getOptionLabel={(option: any) => {
            return `${option.label} - [${option.size}d]`;
          }}
        />
      </div>

      <div
        className={`${StepGroup} ${stepGroupAlias}`}
        style={{ width: "100%" }}
        key={`buffer-assignment-2`}
      >
        <div className={StepLabel}>Procurement Buffer</div>
        <RadioSelect
          key={`buffer-assignment-2-1`}
          isDisabled={!isEditable}
          theme={theme}
          isClearable
          options={bufferMaster?.procMaster}
          value={selectedBuffers[1] || null}
          onChange={(newValue: any) => onValueChange(newValue, "proc")}
          getOptionLabel={(option: any) => {
            return `${option.label} - [${option.size}d]`;
          }}
        />
      </div>
    </div>
  );
};

export default BufferAssignment;
